import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center flex-grow-1 overflow-hidden"
}
const _hoisted_2 = {
  key: 0,
  class: "section-label px-3 mt-4 mb-1 text-overline text-medium-emphasis"
}
const _hoisted_3 = { class: "px-2 pb-2" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center mb-1"
}
const _hoisted_5 = { class: "px-3 py-2 d-flex align-center" }
const _hoisted_6 = { class: "overflow-hidden" }
const _hoisted_7 = { class: "text-subtitle-2 font-weight-bold text-truncate" }
const _hoisted_8 = { class: "text-caption text-medium-emphasis" }
const _hoisted_9 = {
  key: 2,
  class: "app-version text-caption text-disabled text-center pt-2 font-weight-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    app: "",
    rail: _ctx.mini,
    width: 260,
    permanent: "",
    "disable-route-watcher": true,
    color: "surface",
    class: "border-r modern-drawer"
  }, {
    append: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_divider, { class: "mb-2 opacity-50" }),
        (_ctx.mini)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                icon: "mdi-book-open-page-variant-outline",
                variant: "text",
                density: "comfortable",
                size: "small",
                color: "medium-emphasis",
                href: "https://getwud.github.io/wud/",
                target: "_blank",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-book-open-page-variant-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "right"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Documentation", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_component_v_list_item, {
              key: 1,
              href: "https://getwud.github.io/wud/",
              target: "_blank",
              rounded: "lg",
              class: "nav-item mb-1 text-medium-emphasis",
              "prepend-icon": "mdi-book-open-page-variant-outline",
              "append-icon": "mdi-open-in-new"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-medium" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Documentation", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })),
        _createVNode(_component_v_menu, {
          location: "top end",
          offset: "8",
          "close-on-content-click": false
        }, {
          activator: _withCtx(({ props }) => [
            (_ctx.mini)
              ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, props, { class: "d-flex justify-center py-1 cursor-pointer" }), [
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    variant: "tonal",
                    size: "32",
                    class: "font-weight-bold text-caption text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userInitial), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "right"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userName), 1)
                    ]),
                    _: 1
                  })
                ], 16))
              : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 1 }, props, {
                  rounded: "lg",
                  class: "nav-item user-item"
                }), {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      color: "primary",
                      variant: "tonal",
                      size: "30",
                      class: "font-weight-bold text-caption text-primary mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userInitial), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      class: "text-medium-emphasis"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-dots-vertical", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-bold text-truncate" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, { class: "text-caption text-medium-emphasis" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userSubtitle), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "min-width": "250",
              rounded: "lg",
              elevation: "6",
              class: "pa-2 bg-surface border"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    variant: "tonal",
                    size: "36",
                    class: "font-weight-bold text-primary mr-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userInitial), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userName), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userSubtitle), 1)
                  ])
                ]),
                _createVNode(_component_v_divider, { class: "my-2 opacity-50" }),
                _createVNode(_component_v_list_item, {
                  rounded: "md",
                  class: "px-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDarkMode(!_ctx.darkMode)))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: _ctx.darkMode ? 'mdi-weather-night' : 'mdi-weather-sunny',
                      class: "mr-2",
                      size: "20"
                    }, null, 8, ["icon"])
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      "model-value": _ctx.darkMode,
                      "onUpdate:modelValue": _ctx.toggleDarkMode,
                      "hide-details": "",
                      density: "compact",
                      color: "primary",
                      inset: "",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Dark mode", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.user && _ctx.user.username !== 'anonymous')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_v_divider, { class: "my-2 opacity-50" }),
                      _createVNode(_component_v_list_item, {
                        rounded: "md",
                        class: "px-3 text-error",
                        onClick: _ctx.logout
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-logout",
                            color: "error",
                            class: "mr-2",
                            size: "20"
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-medium" }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("Log out", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.mini && _ctx.version)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " WUD v" + _toDisplayString(_ctx.version), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["drawer-header d-flex align-center px-3 pt-3 pb-1", { 'justify-center': _ctx.mini }])
      }, [
        (!_ctx.mini)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_avatar, {
                color: "primary",
                variant: "flat",
                size: "32",
                class: "font-weight-black text-white mr-2 elevation-1 flex-shrink-0"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" W ", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex flex-column overflow-hidden" }, [
                _createElementVNode("span", { class: "text-subtitle-1 font-weight-black tracking-wide brand-title text-truncate" }, "WUD")
              ], -1))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          icon: _ctx.mini ? 'mdi-menu' : 'mdi-chevron-left',
          variant: "text",
          density: "comfortable",
          size: "small",
          color: "medium-emphasis",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"])),
          title: _ctx.mini ? 'Expand sidebar' : 'Collapse sidebar'
        }, null, 8, ["icon", "title"])
      ], 2),
      _createVNode(_component_v_list, {
        nav: "",
        density: "compact",
        class: "px-2 pt-2 pb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, {
            to: "/",
            class: "nav-item mb-1 rounded-lg",
            "prepend-icon": "mdi-home-variant-outline",
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Home", -1)
                ]))]),
                _: 1
              }),
              (_ctx.mini)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    activator: "parent",
                    location: "right"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Home", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item, {
            to: "/containers",
            class: "nav-item mb-1 rounded-lg",
            "prepend-icon": _ctx.containerIcon,
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Containers", -1)
                ]))]),
                _: 1
              }),
              (_ctx.mini)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    activator: "parent",
                    location: "right"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Containers", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["prepend-icon"]),
          (!_ctx.mini)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Configuration "))
            : (_openBlock(), _createBlock(_component_v_divider, {
                key: 1,
                class: "my-3 mx-2 opacity-50"
              })),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurationItemsSorted, (item) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: item.to,
              to: item.to,
              class: "nav-item mb-1 rounded-lg",
              "prepend-icon": item.icon,
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "font-weight-medium text-capitalize" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024),
                (_ctx.mini)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent",
                      location: "right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "prepend-icon"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rail"]))
}